import { render, staticRenderFns } from "./Script.vue?vue&type=template&id=2a12f711&scoped=true"
import script from "./Script.vue?vue&type=script&lang=js"
export * from "./Script.vue?vue&type=script&lang=js"
import style0 from "./Script.vue?vue&type=style&index=0&id=2a12f711&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a12f711",
  null
  
)

export default component.exports